import { provideEffects } from '@ngrx/effects';

import { AppLockEffects } from './category-app-lock.effects';

export const provideCategoryAppLockStore = () => [provideEffects([AppLockEffects])];
